import React from 'react';
import { parseaFechaHora } from '../utils';
import styled from 'styled-components/macro';
import { responsive } from '../resources/constantes.json';

const DatosDeEnvio = ({ datoFecha }) => {
  const [hora, fecha] = parseaFechaHora(datoFecha).split(' - ');
  return (
    <Container>
      <Hora>{hora}</Hora>
      <Fecha>{fecha}</Fecha>
    </Container>
  );
};

export default DatosDeEnvio;

const Container = styled.div`
  box-sizing: border-box;
  padding-right: 1rem;
  text-align: left;
  margin-left: 5%;
  justify-self: flex-end;
  height:44px;
  font-size: 14px;
  color:#fff;
  margin-bottom: 7px;
  > div {
    line-height:22px;
  }
  @media (max-width: ${responsive.mobile}px) {
    margin-bottom: 0px;
  }
`;
const Hora = styled.div`
  color: #00F7F0;
  @media (max-width: ${responsive.mobile}px) {
    //color: #fff;
  }
`;
const Fecha = styled.div`
`;
